import { Observable } from "core/Misc/observable.js";
/**
 * Represents a property that can be observed for changes. The value property is read-only.
 */
export class ReadOnlyObservableProperty {
    get value() {
        return this._value;
    }
    constructor(value) {
        this._onChangedObservable = new Observable();
        this._value = value;
        this.onChangedObservable = this._onChangedObservable;
    }
}
/**
 * Represents a property that can be observed for changes. The setter of the value property
 * will notify observers of the onChangedObservable about the change.
 */
export class ObservableProperty extends ReadOnlyObservableProperty {
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (this._value !== newValue) {
            this._value = newValue;
            this._onChangedObservable.notifyObservers(this._value);
        }
    }
}
//# sourceMappingURL=observableProperty.js.map